export class ErrorModalState {
  messageTranslation!: string[];
}
